
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/CheckUsers/CheckUsers.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./CheckUsers.html');
        
        var script = require('./CheckUsers.ts').default;
        module.exports = require('./CheckUsers.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    